import React, { Component } from "react";
import { connect } from "react-redux";
import FlexView from "react-flexview";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import DailySalesReport from "./dailySalesReport";
import MonthToDateSalesReport from "./monthToDateSalesReport";
import YearToDateReport from "./yearToDateReport";
import LastThreeYearsReport from "./lastThreeYearsReport";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import Container from "../../../../../modules/commons/Container";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import { mapToObjectDDL } from "../../../../common/mapper";
import * as ErrorAction from "../../../../../Redux/ErrorRedux";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";

class KacabReportBySalesman extends Component {
    constructor(props) {
        super(props);
        this.state = {
            kodeCabang: null,
            dataCabang: [],
            search: null,
            loading: false,
            idLeader: null
        };
    };

    componentDidMount = async () => {
        this.fetchDataCabang();
        this.fetchLeaderId();
    };



    fetchDataCabang = async () => {
        try {
            let res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
                setError: this.props.setError,
                menuName: "Dashboard Level Kepala Cabang Keatas - Laporan Harian By Sales",
                args: null,
            });
            if (res.ok) {
                let filteredData = res.data.data.filter(
                    item => this.props.menuAccess.map(data => data.idRefObj).includes(item.kodeCabang)
                );

                if (filteredData.length !== 0) {
                    this.setState((prevValue) => ({
                        ...prevValue,
                        dataCabang: filteredData,
                        kodeCabang: mapToObjectDDL(filteredData[0].namaDealer, filteredData[0].kodeCabang),
                    }));
                }
            }
        } catch (error) {
            console.log("errors", error);
        }
    };

    handleSearchValueChange = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            [name]: value,
        }));
    };

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({ ...prevValue, loading: !prevValue.loading }));
    };

    fetchLeaderId = async () => {
        const idLeader = localStorage.getItem("idLeader");
        const userId = localStorage.getItem("userId");
        if (idLeader) {
            this.setState((prevValue) => ({
                ...prevValue,
                idLeader: idLeader,
            }));
            return;
        }
        this.handleTriggerLoading();
        try {
            let res = await fetchDataAsync({
                asyncFn: () => Api.create("NAGAMAS_MASTER_DATA").findUserById(userId),
                menuName: "Dashboard Level Kepala Cabang Keatas - Laporan Harian By Team Leader",
                setError: this.props.setError,
            });
            if (res.ok) {
                localStorage.setItem("idLeader", res.data.data.id);
                this.setState((prevValue) => ({
                    ...prevValue,
                    idLeader: res.data.data.id,
                }));
            }
        } catch (error) {
            console.log("errors: ", error);
        }
        this.handleTriggerLoading();
    }


    render() {
        return (
            <>
                <Container>
                    <FlexView style={{ gap: "20px", alignItems: "center" }}>
                        <SimpleDDL
                            id="select_options_kode_cabang"
                            box="search"
                            name="kodeCabang"
                            containerclassname="width width-250px"
                            placeholder="Nama Cabang"
                            isClearable
                            menuPosition="fixed"
                            options={
                                this.state.dataCabang.map(
                                    item => mapToObjectDDL(item.namaDealer, item.kodeCabang)
                                )
                            }
                            value={this.state.kodeCabang}
                            onChange={(value, { name }) => this.handleSearchValueChange(name, value)}
                        />
                        <SimpleButton
                            styles={{ marginBottom: "15px" }}
                            // onClick={() => this.handleSearchValueChange("search", this.state.kodeCabang?.value)}
                            onClick={() => {}}
                        >Cari</SimpleButton>
                    </FlexView>
                    <Tabs>
                        <TabList>
                            <Tab>Laporan Jualan Harian</Tab>
                            <Tab>Laporan Jualan Harian By Salesman/CS</Tab>
                            <Tab>Laporan Jualan Month To Date</Tab>
                            <Tab>Laporan Jualan Month To Date By Salesman/CS</Tab>
                            <Tab>Laporan Year To Date</Tab>
                            <Tab>Laporan Jualan 3 Tahun Terakhir</Tab>
                        </TabList>
                        <TabPanel>
                            <DailySalesReport
                                {...this.props}
                                search={this.state.search}
                                kodeCabang={this.state.kodeCabang}
                                triggerLoading={this.handleTriggerLoading}
                                usernameLogin={this.props.auth.user.username}
                            />
                        </TabPanel>
                        <TabPanel>
                            <DailySalesReport
                                {...this.props}
                                tab="salesman"
                                search={this.state.search}
                                kodeCabang={this.state.kodeCabang}
                                triggerLoading={this.handleTriggerLoading}
                                usernameLogin={this.props.auth.user.username}
                                idLeader={this.state.idLeader}
                            />
                        </TabPanel>
                        <TabPanel>
                            <MonthToDateSalesReport
                                {...this.props}
                                tab="salesman"
                                search={this.state.search}
                                kodeCabang={this.state.kodeCabang}
                                triggerLoading={this.handleTriggerLoading}
                                usernameLogin={this.props.auth.user.username}
                                idLeader={this.state.idLeader}
                            />
                        </TabPanel>
                        <TabPanel>
                            <MonthToDateSalesReport
                                {...this.props}
                                tab="tl"
                                search={this.state.search}
                                kodeCabang={this.state.kodeCabang}
                                triggerLoading={this.handleTriggerLoading}
                                usernameLogin={this.props.auth.user.username}
                                idLeader={this.state.idLeader}
                            />
                        </TabPanel>
                        <TabPanel>
                            <YearToDateReport
                                {...this.props}
                                search={this.state.search}
                                kodeCabang={this.state.kodeCabang}
                                triggerLoading={this.handleTriggerLoading}
                                usernameLogin={this.props.auth.user.username}
                                idLeader={this.state.idLeader}
                            />
                        </TabPanel>
                        <TabPanel>
                            <LastThreeYearsReport
                                {...this.props}
                                search={this.state.search}
                                kodeCabang={this.state.kodeCabang}
                                idLeader={this.state.idLeader}
                                triggerLoading={this.handleTriggerLoading}
                                usernameLogin={this.props.auth.user.username}
                            />
                        </TabPanel>
                    </Tabs>
                    {this.state.loading && <SimpleLoadingOverlay active={this.state.loading} />}
                </Container>
            </>
        );
    };
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(KacabReportBySalesman);